module.exports = __webpack_public_path__ + "img/img34.79d0e609.svg";